import { useState, useEffect } from "react";
import "./newUser.css";
import { registerStaff } from "../../redux/apiCalls";
import { useDispatch } from "react-redux";
import { publicRequest } from "../../requestMethods";
import Select from "react-select";
import { commonSelectProps } from "../../components/shared/SelectStyles";
import { useSelector } from "react-redux";

export default function NewUser() {
    const superadmin = useSelector((state) =>
        state.user.currentUser ? state.user.currentUser.isSuperAdmin === true : null
    );
    const currentUser = useSelector((state) => state.user.currentUser);
    const outright = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "outright"
            : null
    );
    const icRequired =
        outright || currentUser?._id === "68707e7e17b78bce728f2254";

    const [inputs, setInputs] = useState({
        outlet: superadmin
            ? undefined
            : outright
            ? currentUser._id
            : currentUser?.principle || currentUser?._id,
    });
    const [usersData, setUsersData] = useState([]);

    const dispatch = useDispatch();

    // Move all hooks before any conditional returns
    useEffect(() => {
        const fetchData = async () => {
            await getAdmins();
        };
        fetchData();
    }, []);

    const handleChange = (e) => {
        setInputs((prev) => {
            return { ...prev, [e.target.name]: e.target.value };
        });
    };

    const handleClick = async (e) => {
        e.preventDefault();
        
        // Check if all required fields are filled
        const requiredFields = ['name', 'email', 'phoneNumber', 'password', 'type'];
        if (icRequired) requiredFields.push('ic');
        const missingFields = [];
        
        requiredFields.forEach(field => {
            if (!inputs[field] || inputs[field].trim() === '') {
                missingFields.push(field);
            }
        });
        
        if (missingFields.length > 0) {
            const fieldNames = {
                name: 'Full Name',
                email: 'Email',
                phoneNumber: 'Phone Number',
                password: 'Password',
                type: 'Type',
                ic: 'IC'
            };
            
            const missingFieldNames = missingFields.map(field => fieldNames[field]).join(', ');
            alert(`Please fill in the following required fields: ${missingFieldNames}`);
            return;
        }
        
        const user = { ...inputs };
        try {
            registerStaff({ user });
        } catch (err) {
            console.log(err);
        }
    };

    const handleInputUserId = (e) => {
        setInputs((prev) => {
            return { ...prev, outlet: e.value };
        });
    };

    const getAdmins = async () => {
        const res = await publicRequest.get("/users/admin", {
            params: {
                type: ["outright", "HQ"],
            },
        });
        setUsersData(res.data);
    };

    return (
        <>
            <div className="newProduct">
                <h1 className="addProductTitle">New Staff</h1>
                <div className="addProductForm">
                    <div className="addProductItem">
                        <label className="required">Full Name</label>
                        <input
                            name="name"
                            type="text"
                            placeholder="Name"
                            onChange={handleChange}
                        />
                    </div>
                    <div className="addProductItem">
                        <label className="required">Email</label>
                        <input
                            name="email"
                            type="text"
                            placeholder="Email"
                            onChange={handleChange}
                        />
                    </div>
                    <div className="addProductItem">
                        <label className="required">Phone Number</label>
                        <input
                            name="phoneNumber"
                            type="text"
                            placeholder="Phone Number"
                            onChange={handleChange}
                        />
                    </div>
                    <div className="addProductItem">
                        <label className={icRequired ? "required" : undefined}>IC</label>
                        <input
                            name="ic"
                            type="text"
                            placeholder="IC Number"
                            onChange={handleChange}
                        />
                    </div>
                    <div className="addProductItem">
                        <label>TIN</label>
                        <input
                            name="tin"
                            type="text"
                            placeholder="Tax Identification Number"
                            onChange={handleChange}
                        />
                    </div>
                    <div className="addProductItem">
                        <label className="required">Password</label>
                        <input
                            name="password"
                            type="password"
                            placeholder="Password"
                            onChange={handleChange}
                        />
                    </div>
                    <div className="addProductItem">
                        <label className="required">Type</label>
                        <div className="react-select-container">
                            <Select
                                options={[
                                    { label: "Manager", value: "manager" },
                                    { label: "Salesman", value: "staff" },
                                    { label: "Drafter", value: "drafter" },
                                    { label: "Purchaser", value: "purchaser" },
                                    { label: "Production", value: "production" },
                                    { label: "Installer", value: "installer" },
                                    {
                                        label: "Installer Manager",
                                        value: "installerManager",
                                    },
                                ]}
                                onChange={(e) => {
                                    setInputs((prev) => {
                                        return { ...prev, type: e.value };
                                    });
                                }}
                                placeholder="Select Type"
                                {...commonSelectProps}
                            />
                        </div>
                    </div>
                    {superadmin && (
                        <div className="addProductItem">
                            <label>Outlet</label>
                            <div className="react-select-container">
                                <Select
                                    options={usersData.map((user, i) => {
                                        return {
                                            label: `${user.name}`,
                                            value: user._id,
                                        };
                                    })}
                                    onChange={handleInputUserId}
                                    placeholder="Select Outlet"
                                    {...commonSelectProps}
                                />
                            </div>
                        </div>
                    )}

                    <button
                        onClick={handleClick}
                        className="updateProductButton formCreateButton"
                    >
                        Create
                    </button>
                </div>
            </div>
        </>
    );
}
